var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 45,
    viewBox: "0 0 37 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9721 8.21441L16.979 8.20829C10.1517 8.19195 4.22474 13.7392 4.17778 20.4583V28.1962C4.17778 29.8091 3.97361 31.3832 3.09366 32.7246L2.5077 33.6189C1.61549 34.9745 2.57507 36.7916 4.17778 36.7916H32.8224C34.4251 36.7916 35.3826 34.9745 34.4924 33.6189L33.9065 32.7246C33.0286 31.3832 32.8224 29.8071 32.8224 28.1942V20.4603C32.7407 13.7392 26.7994 8.23075 19.9721 8.21441V8.21441Z",
    stroke: "#F8CD80",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.625 36.7915C24.625 38.416 23.9797 39.9739 22.831 41.1225C21.6824 42.2712 20.1245 42.9165 18.5 42.9165C16.8755 42.9165 15.3176 42.2712 14.169 41.1225C13.0203 39.9739 12.375 38.416 12.375 36.7915",
    stroke: "#F8CD80",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5003 2.08325C19.5833 2.08325 20.6219 2.51346 21.3877 3.27923C22.1535 4.04501 22.5837 5.08362 22.5837 6.16658V8.20825H14.417V6.16658C14.417 5.08362 14.8472 4.04501 15.613 3.27923C16.3787 2.51346 17.4174 2.08325 18.5003 2.08325Z",
    stroke: "#F8CD80",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.3716a24947ba840b27c0caadededb328.svg";
export { ForwardRef as ReactComponent };